import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../context/LanguageContext";
import { publicPageQueryOptions } from "../lib/publicContentQueries";

export const usePublicPage = (slug) => {
  const { language } = useLanguage();

  return useQuery(publicPageQueryOptions(slug, language));
};
